import { useQuery } from '@tanstack/react-query';
import { CongregationDto, fetchCongregation } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCongregation = (id: number) =>
  useQuery({
    queryFn: async () => {
      const response = await extractData(fetchCongregation({ path: { id } }));
      return response.congregation as CongregationDto & { id: number };
    },
    queryKey: ['congregations', id],
  });
